import i18next from 'i18next';

i18next.addResources('es', 'WorkspaceInvitationRedirect', {
  expiredInvite: 'Esta invitación ha expirado',
  contactOrCreate: 'Puede contactar al administrador del espacio o crearse uno propio.',
  returnToUbuntu: 'Volver a Ubuntulaw'
});
